import React from "react";
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import CommingSoon from "../Components/CommingSoon";

const ChassisCheck = () => {
    return (
        <div className="row">
            <div className="col-1 leftcol">
                {/* <HomeLeft /> */}
            </div>
            <div className="col-10 middlecol">

                <CommingSoon />

                <div className="auction-container">
                    <iframe id="myIframe" src="http://oliac.com/autos/" allowfullscreen></iframe>
                </div>
            </div>
            <div className="col-1 rightcol">
                {/* <HomeRight /> */}
            </div>
        </div>
    );
};

export default ChassisCheck;